import { createSelector } from '@reduxjs/toolkit';

import type { CasinoConfigType } from '../../../api/fetchers/casinoConfig/types';
import type { Compliance } from '../../../api/fetchers/playerConfig/types';
import type { CoreRootState } from '../../CoreStore';

export const selectShouldMergeBonusBalance = createSelector(
  [
    (state: CoreRootState): Compliance | undefined => state.config.playerConfig?.compliance,
    (state: CoreRootState): CasinoConfigType | null => state.config.casinoConfig,
  ],
  (compliance, casinoConfig) => {
    if (!compliance || !casinoConfig) {
      return undefined;
    }
    return !((compliance?.displayBonusBalance || casinoConfig.showBonusBalance) && !casinoConfig.hideBonusBalance);
  }
);
